export const painPoints = [
  'Vous passez des heures à chercher des exercices éparpillés sur internet avant chaque cours.',
  'Vos élèves stagnent parce que vos cours manquent de fil conducteur d’une semaine à l’autre.',
  'Vous improvisez le contenu du cours cinq minutes avant que l’élève sonne à la porte.',
  'Vous n’avez pas de méthode claire pour faire passer un élève du rock au jazz.',
];
